import systemService from '../services/system'

export default {
  system: {
    locale: 'en',
    isLoading: false,
    currentPage: {},
    isMobile: false,
    isColumn: true,
    isScrollToTop: false,
    collapsed: false,
    cacheData: systemService.get_cache(),
    socketLastMessage: null
  },
  auth: {
    userInfo: null,
    factor2: null,
    loginInfo: null
  },
  core: {
    isLocked: true,
    isSync: false,
    syncing: false
  },
  project: {
    projects: [],
    selectedProject: null,
    isFetchProjects: false,
    isAdmin: false,
    isRegular: false,
    isReadOnly: false,
    isFetchProjectSecrets: false,
    isFetchProjectEnvironments: false,
    projectSecrets: [],
    projectEnvironments: []
  },
  workspace: {
    workspaces: [],
    wsRole: null,
    selectedWorkspace: null,
    progressData: [],
    progressDrawers: []
  },
  onboarding: {
    onboardingProcess: {
      step_1: false,
      step_2: false,
      step_3: false,
      step_4: false,
    },
    createProject: false,
    installTool: false,
    createSecret: false,
    createAccessKey: false,
    changeProcessKey: null
  }
}